import { defineComponent as _defineComponent } from 'vue'
import { useStore } from '@nuxtjs/composition-api';
import { type NuxtError } from '@nuxt/types';
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  error: NuxtError;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppError',
  props: {
    error: null
  },
  setup(__props: any) {



const store = useStore();
const menu = store.getters['menus/getMenuMain'];

return { __sfc: true,store, menu, CdnImg }
}

})